<template>
  <div
    :style="chipStyle"
    class="font-bold flex items-center justify-center rounded-full"
  >
    <p
      v-if="!src || imageFailed"
      class="inline-block align-middle uppercase"
    >
      {{ initials }}
    </p>
    <img
      v-else
      :src="src"
      alt=""
      :style="imageStyle"
      class="rounded-full object-cover"
      @error="imageFailed = true"
    >
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
// TODO: Probably needs to be a base component
export default {
  watch: {
    src() {
      this.imageFailed = false;
    },
  },
  props: {
    initials: {
      type: String,
    },
    nameLength: {
      type: Number,
    },
    src: {
      type: String,
    },
    autoColor: {
      type: Boolean,
    },
    backgroundColor: {
      type: String,
    },
    color: {
      type: String,
    },
    size: {
      type: Number,
      default: 50,
    },
    lighten: {
      type: Number,
      default: 80,
    },
  },
  data() {
    return {
      // Expired photo URLs (e.g. old Google avatars) fall back to the initials
      imageFailed: false,
      backgroundColors: [
        '#F44336', '#FF4081', '#9C27B0', '#673AB7',
        '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688',
        '#4CAF50', '#8BC34A', '#CDDC39', /* '#FFEB3B' , */ '#FFC107',
        '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B'],
    };
  },
  computed: {
    background() {
      if (this.src && !this.imageFailed) return 'hsl(0, 0%, 96%)';
      if (this.backgroundColor) {
        return this.backgroundColor;
      }
      return this.randomBackgroundColor(this.nameLength, this.backgroundColors);
    },
    fontColor() {
      return this.color;
    },
    chipStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        backgroundColor: this.background,
        color: this.fontColor,
      };
    },
    imageStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
  methods: {
    randomBackgroundColor(seed, colors) {
      return colors[seed % (colors.length)];
    },
  },
};
</script>

<style scoped>
</style>
